var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "module-card", attrs: { id: _vm.uniqueId } },
    [
      _c(
        "v-img",
        {
          staticClass: "white--text align-end orangebg",
          attrs: { src: _vm.imageURL(_vm.model.uid), height: "240px" }
        },
        [
          _c(
            "v-card-title",
            {
              staticClass: "clear pt-6 white--text bold shadowed wrapped",
              attrs: { id: _vm.uniqueId + "-title" }
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "pl-3",
                  class: { faded: !_vm.available },
                  attrs: { id: _vm.uniqueId + "-row" }
                },
                [_vm._v(" " + _vm._s(_vm.title()) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card-text",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center"
          },
          attrs: { id: _vm.uniqueId + "-card-text" }
        },
        [
          _c(
            "v-chip",
            {
              staticClass: "status-chip",
              staticStyle: { padding: "0", "margin-right": "10px" },
              attrs: { id: _vm.uniqueId + "-status-chip" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { height: "100%", width: "220px" },
                  attrs: { id: _vm.uniqueId + "-status-div" }
                },
                [
                  _vm.loading
                    ? [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center"
                            },
                            attrs: { id: _vm.uniqueId + "-loading-div" }
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "green",
                                size: "30",
                                width: "5"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : [
                        _c("v-progress-linear", {
                          staticClass: "status-progress-bar",
                          staticStyle: {
                            "background-color": "lightgreen",
                            "border-radius": "15px"
                          },
                          attrs: {
                            value: _vm.progress,
                            "aria-labelledby": _vm.uniqueId + "-status-text",
                            height: "100%",
                            color: "green"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "status-text centered",
                            staticStyle: {
                              color: "black",
                              "font-size": "small"
                            },
                            attrs: { id: _vm.uniqueId + "-status-text" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("module-card.progress", [_vm.progress])
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                ],
                2
              )
            ]
          ),
          _c(
            "v-menu",
            {
              attrs: {
                id: _vm.uniqueId + "-menu",
                "offset-y": "",
                attach: "#" + _vm.uniqueId + "-actions-button"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              staticStyle: { height: "32px" },
                              attrs: {
                                id: _vm.uniqueId + "-actions-button",
                                color: "secondary",
                                "aria-describedby": _vm.uniqueId + "-row"
                              }
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("module-card.actions")) + " "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "v-list",
                { attrs: { id: _vm.uniqueId + "-list" } },
                _vm._l(_vm.actions, function(action, index) {
                  return _c(
                    "v-list-item",
                    { key: index },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            id: _vm.uniqueId + "-action-" + index,
                            "aria-label": action.title,
                            tabindex: "0",
                            text: "",
                            block: "",
                            disabled: action.disabled
                          },
                          on: { click: action.action }
                        },
                        [_vm._v(" " + _vm._s(action.title) + " ")]
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-card-text", { attrs: { id: _vm.uniqueId + "-promo-text" } }, [
        _vm._v(" " + _vm._s(_vm.promoText()) + " ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }